import {
  SET_ASSOCIATED_BUSINESSES,
  SET_ACTIVE_SERVICE_ID,
  SET_ACTIVE_SERVICE,
  SET_ACTIVE_BUSINESS_ID,
  SET_ERROR,
  SET_LOADING,
  SET_OPEN_RIGHT_DETAILS_PANEL,
  SET_SERVICES,
  SET_TENANT_SETTINGS,
  SET_TAB_STATE,
  SET_TOAST,
  SET_RIDE_INFO,
  SET_PROFILE_FORM_PANEL,
} from "./actionTypes";

export const initialState = {
  associatedBusinesses: [],
  activeBusinessId: null,
  activeService: null,
  activeServiceId: null,
  error: {
    hasError: false,
    errorMessage: ""
  },
  loading: false,
  openRightDetailsPanel: false,
  profileFormPanel: { type: "admin", data: null },
  rideInfo: {},
  services: [],
  tabState: "create",
  tenantSettings: null,
  toast: {
    open: false, 
    variant: null,
    message: null
  }
};

const updateReducer = (state, updatedState) => ({
  ...state,
  ...updatedState
});

export const globalReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_ASSOCIATED_BUSINESSES:
      return updateReducer(state, { associatedBusinesses: action.payload });
    case SET_ACTIVE_BUSINESS_ID:
      return updateReducer(state, { activeBusinessId: action.payload });
    case SET_ACTIVE_SERVICE:
      return updateReducer(state, { activeService: action.payload });
    case SET_ACTIVE_SERVICE_ID:
      return updateReducer(state, { activeServiceId: action.payload });
    case SET_ERROR:
      return updateReducer(state, { error: action.payload });
    case SET_LOADING:
      return updateReducer(state, { loading: action.payload });
    case SET_OPEN_RIGHT_DETAILS_PANEL:
      return updateReducer(state, { openRightDetailsPanel: action.payload });
    case SET_PROFILE_FORM_PANEL:
      return updateReducer(state, { profileFormPanel: action.payload });
    case SET_RIDE_INFO:
      return updateReducer(state, { rideInfo: action.payload });
    case SET_SERVICES:
      return updateReducer(state, { services: action.payload });
    case SET_TAB_STATE:
      return updateReducer(state, { tabState: action.payload });
    case SET_TENANT_SETTINGS:
      return updateReducer(state, { tenantSettings: action.payload });
    case SET_TOAST: {
      const { open, variant, message } = action.payload
      return updateReducer(state, { toast: {open: open, variant: variant, message: message}});
    }
    default:
      return state;
  }
};
